import AuthService from './AuthService';
import RequestBuilder from '../Lib/Requests';

export default class SchedulesService {
  auth = new AuthService();
  api = new RequestBuilder();

  buildSchedulesForOrgRequest({ params, cancelToken }) {
    return {
      service: 'rules',
      endpoint: '/v1/schedule',
      method: 'get',
      params,
      cancelToken,
    };
  }
  async fetchSchedulesForOrg(params) {
    const { data = {} } = await this.api.request(
      this.buildSchedulesForOrgRequest(params)
    );
    return data;
  }

  buildScheduleRequest({
    orgID = this.auth.getCurrentOrgID(),
    scheduleId,
    cancelToken,
  }) {
    return {
      service: 'rules',
      endpoint: `/v1/schedule/${scheduleId}`,
      method: 'get',
      params: { orgID },
      cancelToken,
    };
  }
  async fetchSchedule(params) {
    const { data = {} } = await this.api.request(
      this.buildScheduleRequest(params)
    );
    return data;
  }

  buildCreateScheduleRequest({
    orgID = this.auth.getCurrentOrgID(),
    data,
    cancelToken,
  }) {
    return {
      service: 'rules',
      endpoint: '/v1/schedule',
      method: 'post',
      params: { orgID },
      data,
      cancelToken,
    };
  }
  async createSchedule(params) {
    const { data = {} } = await this.api.request(
      this.buildCreateScheduleRequest(params)
    );
    return data;
  }

  buildDeleteScheduleRequest({
    orgID = this.auth.getCurrentOrgID(),
    scheduleId,
  }) {
    return {
      service: 'rules',
      endpoint: `/v1/schedule/${scheduleId}`,
      method: 'delete',
      params: { orgID },
    };
  }
  async deleteSchedule(params) {
    const { data = {} } = await this.api.request(
      this.buildDeleteScheduleRequest(params)
    );
    return data;
  }

  buildUpdateScheduleRequest({
    orgID = this.auth.getCurrentOrgID(),
    scheduleId,
    data,
    cancelToken,
  }) {
    return {
      service: 'rules',
      endpoint: `/v1/schedule/${scheduleId}`,
      method: 'put',
      params: { orgID },
      data,
      cancelToken,
    };
  }
  async updateSchedule(params) {
    const { data = {} } = await this.api.request(
      this.buildUpdateScheduleRequest(params)
    );
    return data;
  }

  buildAddGatewayRequest({
    orgID = this.auth.getCurrentOrgID(),
    scheduleId,
    data,
    cancelToken,
  }) {
    return {
      service: 'rules',
      endpoint: `/v1/schedule/${scheduleId}/gateway`,
      method: 'post',
      params: {
        orgID,
      },
      data,
      cancelToken,
    };
  }
  async addGateway(params) {
    const { data = {} } = await this.api.request(
      this.buildAddGatewayRequest(params)
    );
    return data;
  }

  buildDeleteGatewayRequest({
    orgID = this.auth.getCurrentOrgID(),
    scheduleId,
    gatewayId,
    cancelToken,
  }) {
    return {
      service: 'rules',
      endpoint: `/v1/schedule/${scheduleId}/gateway/${gatewayId}`,
      method: 'delete',
      params: {
        orgID,
      },
      cancelToken,
    };
  }
  async deleteGateway(params) {
    const { data = {} } = await this.api.request(
      this.buildDeleteGatewayRequest(params)
    );
    return data;
  }

  buildCreateReminderRequest(params, data, cancelToken) {
    return {
      service: 'rules',
      endpoint: '/v1/reminder',
      method: 'post',
      params,
      data,
      cancelToken,
    };
  }
  async createReminder(params, body, cancelToken) {
    const { data = {} } = await this.api.request(
      this.buildCreateReminderRequest(params, body, cancelToken)
    );
    return data;
  }

  buildUpdateReminderRequest(reminderID, params, data, cancelToken) {
    return {
      service: 'rules',
      endpoint: `/v1/reminder/${reminderID}`,
      method: 'put',
      params,
      data,
      cancelToken,
    };
  }
  async updateReminder(reminderID, params, body, cancelToken) {
    const { data = {} } = await this.api.request(
      this.buildUpdateReminderRequest(reminderID, params, body, cancelToken)
    );
    return data;
  }

  buildDeleteReminderRequest(reminderID, params, cancelToken) {
    return {
      service: 'rules',
      endpoint: `/v1/reminder/${reminderID}`,
      method: 'delete',
      params,
      cancelToken,
    };
  }
  deleteReminder(reminderID, params, cancelToken) {
    return this.api.request(
      this.buildDeleteReminderRequest(reminderID, params, cancelToken)
    );
  }

  buildReminderInstancesRequest(params, cancelToken) {
    return {
      service: 'rules',
      endpoint: '/v1/reminder-instance',
      method: 'get',
      params,
      cancelToken,
    };
  }
  async fetchReminderInstances(params, cancelToken) {
    const { data = {} } = await this.api.request(
      this.buildReminderInstancesRequest(params, cancelToken)
    );
    return data;
  }

  buildEditReminderInstancesRequest({
    orgID = this.auth.getCurrentOrgID(),
    instanceId,
    data,
    cancelToken,
  }) {
    return {
      service: 'rules',
      endpoint: `/v1/reminder-instance/${instanceId}`,
      method: 'put',
      params: {
        orgID,
      },
      data,
      cancelToken,
    };
  }
  async editReminderInstance(params) {
    const { data = {} } = await this.api.request(
      this.buildEditReminderInstancesRequest(params)
    );
    return data;
  }

  buildFetchScheduleGatewayRequest({
    orgID = this.auth.getCurrentOrgID(),
    scheduleId,
    cancelToken,
  }) {
    return {
      service: 'rules',
      endpoint: `/v1/schedule/${scheduleId}/gateway`,
      method: 'get',
      params: { orgID },
      cancelToken,
    };
  }
  async fetchScheduleGateways(params) {
    const { data = [] } = await this.api.request(
      this.buildFetchScheduleGatewayRequest(params)
    );
    return data;
  }

  buildReminderTriggersRequest({
    orgID = this.auth.getCurrentOrgID(),
    instanceId,
    cancelToken,
  }) {
    return {
      service: 'rules',
      endpoint: '/v1/reminder-trigger',
      method: 'get',
      params: {
        orgID,
        instanceIdFilter: instanceId,
      },
      cancelToken,
    };
  }
  async fetchReminderTriggers(params) {
    const { data = {} } = await this.api.request(
      this.buildReminderTriggersRequest(params)
    );
    return data;
  }

  buildAddServiceManualRequest({ scheduleId, data, orgID, cancelToken }) {
    return {
      service: 'rules',
      endpoint: `/v1/schedule/${scheduleId}/service-manual`,
      method: 'put',
      params: { orgID },
      data,
      cancelToken,
    };
  }
  async addServiceManual(params) {
    const { data = {} } = await this.api.request(
      this.buildAddServiceManualRequest(params)
    );
    return data;
  }

  buildGetServiceManualRequest({ scheduleId, orgID, cancelToken }) {
    return {
      service: 'rules',
      endpoint: `/v1/schedule/${scheduleId}/service-manual`,
      method: 'get',
      params: { orgID },
      cancelToken,
    };
  }
  async getServiceManual(params) {
    const { data = {} } = await this.api.request(
      this.buildGetServiceManualRequest(params)
    );
    return data;
  }

  buildDeleteServiceManualRequest({ scheduleId, orgID, cancelToken }) {
    return {
      service: 'rules',
      endpoint: `/v1/schedule/${scheduleId}/service-manual`,
      method: 'delete',
      params: { orgID },
      cancelToken,
    };
  }
  async deleteServiceManual(params) {
    const { data = {} } = await this.api.request(
      this.buildDeleteServiceManualRequest(params)
    );
    return data;
  }

  buildAddReminderAttachmentRequest({
    scheduleId,
    reminderId,
    data,
    orgID,
    cancelToken,
  }) {
    return {
      service: 'rules',
      endpoint: `/v1/schedule/${scheduleId}/attachment/${reminderId}`,
      method: 'put',
      params: { orgID },
      data,
      cancelToken,
    };
  }
  async addReminderAttachment(params) {
    const { data = {} } = await this.api.request(
      this.buildAddReminderAttachmentRequest(params)
    );
    return data;
  }

  buildGetReminderAttachmentRequest({
    scheduleId,
    reminderId,
    orgID,
    cancelToken,
  }) {
    return {
      service: 'rules',
      endpoint: `/v1/schedule/${scheduleId}/attachment/${reminderId}`,
      method: 'get',
      params: { orgID },
      cancelToken,
    };
  }
  async getReminderAttachment(params) {
    const { data = {} } = await this.api.request(
      this.buildGetReminderAttachmentRequest(params)
    );
    return data;
  }

  buildDeleteReminderAttachmentRequest({
    scheduleId,
    reminderId,
    orgID,
    cancelToken,
  }) {
    return {
      service: 'rules',
      endpoint: `/v1/schedule/${scheduleId}/attachment/${reminderId}`,
      method: 'delete',
      params: { orgID },
      cancelToken,
    };
  }
  async deleteReminderAttachment(params) {
    const { data = {} } = await this.api.request(
      this.buildDeleteReminderAttachmentRequest(params)
    );
    return data;
  }

  buildAddMaintenanceLog({ reminderTriggerId, cancelToken }) {
    return {
      service: 'rules',
      endpoint: `/v1/reminder-trigger/${reminderTriggerId}/maintenance-log`,
      method: 'post',
      cancelToken,
    };
  }
  async addMaintenanceLog(params) {
    const { data = {} } = await this.api.request(
      this.buildAddMaintenanceLog(params)
    );
    return data;
  }

  buildAddMaintenanceLogBulk({ orgID, data, cancelToken }) {
    return {
      service: 'rules',
      endpoint: '/v1/reminder-trigger/maintenance-log/bulk',
      method: 'post',
      params: { orgID },
      data,
      cancelToken,
    };
  }
  async addMaintenanceLogBulk(params) {
    const { data = {} } = await this.api.request(
      this.buildAddMaintenanceLogBulk(params)
    );
    return data;
  }

  buildFetchOrgMaintenanceMetricsRequest(params, cancelToken) {
    return {
      service: 'rules',
      endpoint: '/v1/metrics/maintenance',
      method: 'get',
      params,
      cancelToken,
    };
  }
  async fetchOrgMaintenanceMetrics(params, cancelToken) {
    const { data = {} } = await this.api.request(
      this.buildFetchOrgMaintenanceMetricsRequest(params, cancelToken)
    );
    return data;
  }

  buildFetchAssetsForMaintenanceDashboardRequest(params, cancelToken) {
    return {
      service: 'rules',
      endpoint: '/v1/metrics/gateway/reminders',
      method: 'get',
      params,
      cancelToken,
    };
  }
  async fetchAssetsForMaintenanceDashboard(params, cancelToken) {
    const { data = {} } = await this.api.request(
      this.buildFetchAssetsForMaintenanceDashboardRequest(params, cancelToken)
    );
    return data;
  }
}
